import { getReservationKey } from '../../helpers';
import * as actionTypes from '../actions';


const initialState = {
    surveyAnswered: false,

    defaultSurvey: null,
    getDefaultSurveyLoading: false,
    getDefaultSurveyError: null,

    surveysStatus: null,
    getSurveysStatusLoading: false,
    getSurveysStatusError: null,

    answerSurveyLoading: false,
    answerSurveyError: null,
};

const feedbacksReducer = (state=initialState, action) => {
    switch (action.type) {

        // GET SURVEYS
        case actionTypes.GET_DEFAULT_SURVEY_REQUEST:
            return {
                ...state,
                getDefaultSurveyLoading: true,
            };
        case actionTypes.GET_DEFAULT_SURVEY_SUCCESS:
            return {
                ...state,
                getDefaultSurveyLoading: false,
                getDefaultSurveyError: null,
                defaultSurvey: action.data,
            };
        case actionTypes.GET_DEFAULT_SURVEY_ERROR:
            return {
                ...state,
                getDefaultSurveyLoading: false,
                getDefaultSurveyError: action.error,
            };
        
        // ANSWER SURVEY
        case actionTypes.ANSWER_SURVEY_REQUEST:
            return {
                ...state,
                answerSurveyLoading: true,
            };
        case actionTypes.ANSWER_SURVEY_SUCCESS:
            return {
                ...state,
                answerSurveyLoading: false,
                answerSurveyError: null,
                surveyAnswered: true,
            };
        case actionTypes.ANSWER_SURVEY_ERROR:
            return {
                ...state,
                answerSurveyLoading: false,
                answerSurveyError: action.error,
                surveyAnswered: false,
            };

        // GET SURVEYS
        case actionTypes.GET_SURVEYS_STATUS_REQUEST:
            return {
                ...state,
                getSurveysStatusLoading: true,
            };
        case actionTypes.GET_SURVEYS_STATUS_SUCCESS:
            return {
                ...state,
                getSurveysStatusLoading: false,
                getSurveysStatusError: null,
                surveysStatus: action.data,
                surveyAnswered: action.data.answered_barestho_survey || action.data.answered_default_survey,
            };
        case actionTypes.GET_SURVEYS_STATUS_ERROR:
            return {
                ...state,
                getSurveysStatusLoading: false,
                getSurveysStatusError: action.error,
                surveyAnswered: false,
            };

        default:
            return state;
    }
};

export default feedbacksReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/feedbacks.js